import request from '@/utils/request'

export function getAll() {
  return request({
    url: '/areas/all',
    method: 'Get'
  })
}

